import {
  combineComparators,
  compareAsDates,
  compareAsMagnitudes,
  compareAsNumbers,
  compareAsStrings,
} from 'comparators';
import ledgerCategoryOrderingTypes from './ledgerCategoryOrderingTypes';

export const compareVendorNames = (dataEntryA, dataEntryB) =>
  compareAsStrings(dataEntryA.journalEntry.vendorName, dataEntryB.journalEntry.vendorName);

export const compareDataEntryLedgerAccountNames = (dataEntryA, dataEntryB) =>
  compareAsStrings(
    dataEntryA.ledgerAccount ? dataEntryA.ledgerAccount.name : '',
    dataEntryB.ledgerAccount ? dataEntryB.ledgerAccount.name : '',
  );

export const compareAmountMagnitudes = (dataEntryA, dataEntryB) =>
  compareAsMagnitudes(dataEntryA.amountInCents, dataEntryB.amountInCents);

export const compareAmountValues = (dataEntryA, dataEntryB) =>
  compareAsNumbers(dataEntryA.amountInCents, dataEntryB.amountInCents);

export const compareTransactionDates = (dataEntryA, dataEntryB) =>
  compareAsDates(
    dataEntryA.journalEntry.dateOfTransaction,
    dataEntryB.journalEntry.dateOfTransaction,
  );

export const compareAllDataEntries = combineComparators([
  compareVendorNames,
  compareDataEntryLedgerAccountNames,
  compareAmountMagnitudes,
  compareAmountValues,
  compareTransactionDates,
]);

export const ledgerAccountComparators = {
  [ledgerCategoryOrderingTypes.ALPHABETICAL]: (ledgerA, ledgerB) =>
    compareAsStrings(ledgerA.name, ledgerB.name),
  [ledgerCategoryOrderingTypes.CUSTOM]: (ledgerA, ledgerB) =>
    compareAsNumbers(ledgerA.order, ledgerB.order),
};

export const compareNotesDates = (noteA, noteB) => compareAsDates(noteA.createdOn, noteB.createdOn);
